import { LegalLayout } from '../../components/LegalLayout';
import { t } from '../../hooks/useT';
import { LegalBody } from './LegalBodies';

export function CGUPage() {
  return (
    <LegalLayout title={t('legal.cgu.title')} lead={t('legal.cgu.lead')}>
      <LegalBody page="cgu" />
    </LegalLayout>
  );
}
